import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthenticationGuard } from '@app/auth/authentication.guard';
import { ErrorPageComponent } from '@app/error-page/error-page.component';

import { Shell } from '@app/shell/shell.service';

//import { PhutureLoginComponent } from './phuture-login/phuture-login.component';
//import { DashboardComponent } from './dashboard/dashboard.component';
//import { FirststartComponent } from './firststart/firststart.component';

const routes: Routes = [
  // Auth routes (login, logout, etc.) - accessible without authentication
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  
  // Redirect auth sub-routes to root level
  { path: 'login', redirectTo: '/auth/login', pathMatch: 'full' },
  { path: 'logout', redirectTo: '/auth/logout', pathMatch: 'full' },
  { path: 'forgot-pwd', redirectTo: '/auth/forgot-pwd', pathMatch: 'full' },
  { path: 'register-new', redirectTo: '/auth/register-new', pathMatch: 'full' },
  { path: 'reset-pwd', redirectTo: '/auth/reset-pwd', pathMatch: 'full' },
  
  // Standalone error pages (without shell) - MUST come before shell routes
  {
    path: 'error',
    component: ErrorPageComponent,
    data: { title: 'Fehler' },
  },
  {
    path: 'error-404',
    component: ErrorPageComponent,
    data: { title: 'Fehler 404' },
  },
  {
    path: '404',
    component: ErrorPageComponent,
    data: { title: 'Fehler 404' },
  },
  {
    path: 'fdsa',
    redirectTo: '/error-404',
    pathMatch: 'full'
  },
  
  // Default route redirect to dashboard (will be handled by AuthenticationGuard)
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  
  Shell.childRoutes([
    //{ path: 'login', loadChildren: () => import('./phuture-login/phuture-login.module').then((m) => m.PhutureLoginModule) },
    //{path: 'first', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
    //{} path: 'about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
    //{ path: 'settings', loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule) },
    //{ path: 'support', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) }
    // Lazy-loaded routes moved to shell-routing.module.ts
  ]),

  // Fallback when no prior route is matched - redirect to error page
  { path: '**', redirectTo: '/error-404', pathMatch: 'full' },
];

/*
const routes: Routes = [
  //{ path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '',
    canActivate: [],
    component: PhutureLoginComponent,
    data: { title: 'Atout' },
  },

  {
    path: 'home',
    canActivate: [AuthenticationGuard],
    component: DashboardComponent,
    data: { title: 'Home' },
    // List and form component is the child component of sidebar3 component.
    children: [
      {
        // When you click go to list, it navigate to list component page.
        path: 'edit',
        component: FirststartComponent,
      },
    ],
  },

  // this firststart routine is only vor the visitors
  {
    path: 'firststart',
    canActivate: [AuthenticationGuard], // AppDataSyncGuard
    component: FirststartComponent,
    data: { title: 'Home' },
  },


];
*/

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
